import React from "react";
import { useRouter } from "next/router";
import styles from "./IndustryExpertise.module.scss";
import PersonalCareSVG from "./PersonalCareSVG";
import HomeCareAndIndustrialCleaningSVG from "./HomeCareAndIndustrialCleaningSVG";
import FlavoursAndFragranceSVG from "./FlavoursAndFragranceSVG";
import FoodAndNutritionSVG from "./FoodAndNutritionSVG";
import OilAndGasSVG from "./OilAndGasSVG";
import ChemicalIntermediatesSVG from "./ChemicalIntermediatesSVG";
import WaterTreatmentAndMiningSVG from "./WaterTreatmentAndMiningSVG";
import CaseSVG from "./CaseSVG";
import { useState, useEffect } from "react";

// SVG mapping based on industry ID
const svgMapping = {
  1: WaterTreatmentAndMiningSVG,
  2: OilAndGasSVG,
  3: PersonalCareSVG,
  4: FoodAndNutritionSVG,
  5: FlavoursAndFragranceSVG,
  6: HomeCareAndIndustrialCleaningSVG,
  7: ChemicalIntermediatesSVG,
  8: CaseSVG,
};

// Default industries fallback in case API fails
const defaultIndustries = [
  { id: 3, title: "Personal Care", svg: PersonalCareSVG },
  {
    id: 6,
    title: "Home Care and Industrial Cleaning",
    svg: HomeCareAndIndustrialCleaningSVG,
  },
  { id: 5, title: "Flavours and Fragrance", svg: FlavoursAndFragranceSVG },
  { id: 2, title: "Oil and Gas", svg: OilAndGasSVG },
  { id: 4, title: "Food and Nutrition", svg: FoodAndNutritionSVG },
  { id: 7, title: "Chemical Intermediates", svg: ChemicalIntermediatesSVG },
  { id: 8, title: "C.A.S.E.", svg: CaseSVG },
  { id: 1, title: "Water Treatment & Mining", svg: WaterTreatmentAndMiningSVG },
];

const IndustryCard = ({ industry, onClick, isDesktop }) => {
  return (
    <div className={styles.industryCard} onClick={onClick}>
      {/* Concentric Svg or Image */}
      {/* <div className={styles.concentricSvg}>
        {isDesktop ? (
          industry.svg()
        ) : (
          <Image
            src={FoodAndNutritionImg}
            alt="Food and Nutrition"
            width={44}
            height={44}
          />
        )}
      </div> */}
      {industry.svg()}
      {/* Title */}
      <div className={styles.title}>{industry.title}</div>
    </div>
  );
};

function IndustryExpertise({ subheading, heading, industryList = [] }) {
  const router = useRouter();
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 800);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Process industryList to add SVG components based on ID
  const processedIndustries = React.useMemo(() => {
    if (industryList && industryList.length > 0) {
      return industryList.map((industry) => ({
        ...industry,
        svg: svgMapping[industry.id] || (() => <div>No SVG</div>), // Fallback if no SVG found
      }));
    }
    return defaultIndustries;
  }, [industryList]);

  const handleIndustryClick = (industry) => {
    const formattedName = industry.title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[&]/g, "");
    router.push(`/industry/${formattedName}-${industry.id}`);
  };

  return (
    <div className={styles.industryExpertise}>
      {/* Small Heading */}
      <h6>{subheading}</h6>
      {/* Big Heading */}
      <h2>{heading}</h2>
      {/* Industry Cards Grid */}
      <div className={styles.cardsGrid}>
        {processedIndustries.map((industry) => (
          <IndustryCard
            key={industry.id}
            industry={industry}
            onClick={() => handleIndustryClick(industry)}
            isDesktop={isDesktop}
          />
        ))}
      </div>
    </div>
  );
}

export default IndustryExpertise;
